export default __webpack_public_path__ + "assets/images/office_2Rb5x.jpg";